// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.label_bXC2t{
  display: flex;
  flex-direction: column;
  color: var(--_71-color);
  gap: 5px;
  border-bottom: 1px solid var(--eb-border);
  margin-top: 20px;
}
.detailsBill_dLtYB {
  display: flex;
  margin-bottom: 20px;
  p {
    width: 100%;
  }

  .optionsDetailsBill_quT78 {
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: end;
    flex-wrap: wrap;
    justify-content: end;
  }
}
.button_jZLud {
  background-color: transparent;
  border: none;
  outline: none;
  text-decoration: underline;
  cursor: pointer;
  color: var(--_2-color);
  font-weight: 500;
  padding: 0;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  min-width: fit-content;
}
.infoBillContainer_z0a4V {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.infoBill_Mk0c_ {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  span {
    color: var(--_71-color);
  }
  .defaultAddress_Fdv3e {
    display: flex;
    width: 100%;
    justify-content: end;
    align-items: center;
    span {
      color: var(--_2ebc89-color);
    }
  }
  .infoBillContainer_z0a4V {
    width: 100%;
    display: flex;
    align-items: center;
    .info_cBgDQ {
      align-items: center;
      justify-content: space-between;
    }
  }
  .info_cBgDQ {
    display: flex;
    width: 100%;
    gap: 10px;
    span {
      width: fit-content;
      color: var(--_71-color);
    }
  }
}

.footerDetailsbill_bZyYl{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.deleteContact_PWFAm {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: var(--dc3545-background);
  gap: 7px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.9px;
  cursor: pointer;

  .icon_SPoPP {
    display: flex;
    padding: 5px;
    align-items: center;
    gap: 10px;
    border-radius: 200px;
    background: var(--ed-background);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InfoContact/DetailsBillLabel/DetailsBillLabel.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;IACf,oBAAoB;EACtB;AACF;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB;MACE,2BAA2B;IAC7B;EACF;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB;MACE,mBAAmB;MACnB,8BAA8B;IAChC;EACF;EACA;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT;MACE,kBAAkB;MAClB,uBAAuB;IACzB;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;;EAEf;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,gCAAgC;EAClC;AACF","sourcesContent":["\n.label{\n  display: flex;\n  flex-direction: column;\n  color: var(--_71-color);\n  gap: 5px;\n  border-bottom: 1px solid var(--eb-border);\n  margin-top: 20px;\n}\n.detailsBill {\n  display: flex;\n  margin-bottom: 20px;\n  p {\n    width: 100%;\n  }\n\n  .optionsDetailsBill {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    text-align: end;\n    flex-wrap: wrap;\n    justify-content: end;\n  }\n}\n.button {\n  background-color: transparent;\n  border: none;\n  outline: none;\n  text-decoration: underline;\n  cursor: pointer;\n  color: var(--_2-color);\n  font-weight: 500;\n  padding: 0;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  min-width: fit-content;\n}\n.infoBillContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.infoBill {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 25px;\n  span {\n    color: var(--_71-color);\n  }\n  .defaultAddress {\n    display: flex;\n    width: 100%;\n    justify-content: end;\n    align-items: center;\n    span {\n      color: var(--_2ebc89-color);\n    }\n  }\n  .infoBillContainer {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    .info {\n      align-items: center;\n      justify-content: space-between;\n    }\n  }\n  .info {\n    display: flex;\n    width: 100%;\n    gap: 10px;\n    span {\n      width: fit-content;\n      color: var(--_71-color);\n    }\n  }\n}\n\n.footerDetailsbill{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.deleteContact {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  color: var(--dc3545-background);\n  gap: 7px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16.9px;\n  cursor: pointer;\n\n  .icon {\n    display: flex;\n    padding: 5px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 200px;\n    background: var(--ed-background);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_bXC2t`,
	"detailsBill": `detailsBill_dLtYB`,
	"optionsDetailsBill": `optionsDetailsBill_quT78`,
	"button": `button_jZLud`,
	"infoBillContainer": `infoBillContainer_z0a4V`,
	"infoBill": `infoBill_Mk0c_`,
	"defaultAddress": `defaultAddress_Fdv3e`,
	"info": `info_cBgDQ`,
	"footerDetailsbill": `footerDetailsbill_bZyYl`,
	"deleteContact": `deleteContact_PWFAm`,
	"icon": `icon_SPoPP`
};
export default ___CSS_LOADER_EXPORT___;
